<form [formGroup]="createForm" class="form-validation" (ngSubmit)="onSubmit()" *ngIf="occ_details, notification_time">
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{ lang?.repetititonData }}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">

    <div class="row">

      <ng-template #ErrorMsg let-msg="msg" let-value="value" let-submitted="submitted">
        <div *ngFor="let validation of msg">
          <div class="error-message"
            *ngIf="value.hasError(validation.type) && (value.touched || value.dirty || submitted)">
            {{validation.message}}
          </div>
        </div>
      </ng-template>

      <div class="form-group col-sm-12">
        <label>{{ lang.firstemissionDate }}</label>

        <input type="date" class="form-control" formControlName="start_days" [ngClass]="formErrorClass(createForm.controls.start_days, createFormSubmitted)">
        

        <ng-template [ngTemplateOutlet]="ErrorMsg" [ngTemplateOutletContext]="{msg:createFormErrorMsg.start_days, value:createForm.controls.start_days, submitted:createFormSubmitted }"></ng-template>

      </div>

        <div class="col-md-4">
        <label>{{ lang.repeatingPeriod }}</label>
        </div>

        <div class="col-md-4">
        <input type="text" class="form-control" formControlName="repeat_period" [ngClass]="formErrorClass(createForm.controls.repeat_period, createFormSubmitted)">

        <ng-template [ngTemplateOutlet]="ErrorMsg" [ngTemplateOutletContext]="{msg:createFormErrorMsg.repeat_period, value:createForm.controls.repeat_period, submitted:createFormSubmitted }"></ng-template>

        </div>
        <div class="col-md-4">
          <select class="form-control" formControlName="rep_types" [ngClass]="formErrorClass(createForm.controls.rep_types, createFormSubmitted)">
            <option [ngValue]="null" disabled>{{ lang.select }}</option>
            <option *ngFor="let type of typePeriod" [ngValue]="type.value">{{type.text}}</option>
          </select> 
          
          <ng-template [ngTemplateOutlet]="ErrorMsg" [ngTemplateOutletContext]="{msg:createFormErrorMsg.rep_types, value:createForm.controls.rep_types, submitted:createFormSubmitted }"></ng-template>

  
        </div>

        <br><br>
        <div class="col-md-4">
        </div>
        
 
    
      <div class="form-group col-sm-12">
        <label>{{ lang.daystoNotify }}</label>
        <input type="text" class="form-control" formControlName="days_notify" [ngClass]="formErrorClass(createForm.controls.days_notify, createFormSubmitted)">

        <ng-template [ngTemplateOutlet]="ErrorMsg" [ngTemplateOutletContext]="{msg:createFormErrorMsg.days_notify, value:createForm.controls.days_notify, submitted:createFormSubmitted }"></ng-template>

        <div *ngIf="createForm.hasError('range')" style="color: red;">
          Days notify should be less than the repetition.

        </div>
      </div>

      <div class="col-sm-12">
        <label>{{ lang.notificationTime }}</label>

        <select class="form-control" formControlName="notify_time" [ngClass]="formErrorClass(createForm.controls.notify_time, createFormSubmitted)">
          <option value="">{{ lang.selectTime }}</option>
          <option *ngFor="let type of notification_time" [ngValue]="type">{{type}}</option>
        </select> 

        <ng-template [ngTemplateOutlet]="ErrorMsg" [ngTemplateOutletContext]="{msg:createFormErrorMsg.notify_time, value:createForm.controls.notify_time, submitted:createFormSubmitted }"></ng-template>

      </div>  


      <div class="col-sm-12" formArrayName="send_email">
        <label>{{lang.referenceEmail}}</label>
        <div class="form-group row" *ngFor="let email of send_email().controls; let i=index">
          <div class="col-sm-11">
            <input type="text" class="form-control" formControlName="{{i}}" [ngClass]="formErrorClass(send_email().controls[i], createFormSubmitted)">
            
            <ng-template [ngTemplateOutlet]="ErrorMsg" [ngTemplateOutletContext]="{msg:createFormErrorMsg.send_email, value:send_email().controls[i], submitted:createFormSubmitted }"></ng-template>

          </div>
          <div class="col-sm-1">
            <button class="btn btn-primary pull-right" type="button" (click)="removeEmail(i)" *ngIf=" i!=(send_email().controls.length-1) ">
              <i class="fa fa-trash-o"></i>
            </button>
            <button class="btn btn-primary pull-right" type="button" (click)="addEmail()" *ngIf=" i==(send_email().controls.length-1) ">
              <i class="fa fa-plus"></i>
            </button>
          </div>
        </div>
      </div>
    
    
    
    </div>


  </div>
     
  <div class="modal-footer">
    <div  *ngIf="rolepermission;then content else other_content"></div>    

    <ng-template #other_content><button type="submit" class="btn btn-success">{{ lang.save }}</button></ng-template>
    
    <button type="button" class="btn btn-warning" (click)="bsModalRef.hide()">Close</button>
  </div>
</form>

<ng-template #imagePreviewRef let-link='imageLink'>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Image Preview</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body section-spaces">
    <app-image-preview [imageUrl]="imageLink"></app-image-preview>
    <ngx-doc-viewer url="https://angular-doc-viewer.firebaseapp.com/assets/file-sample_150kB.pdf" viewer="google" style="width:100%;height:50vh;"></ngx-doc-viewer>
  </div>
</ng-template>

